export default __webpack_public_path__ + "static/media/MediumSBExcessiveMovementEdited.33a6b649.mp4";